import { Spinner, Button } from "@chakra-ui/react";
import { to } from "@lib/utils";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { useAtom } from "jotai";
import { useRef } from "react";
import { markDiscount } from "services/discount";
import { markTicket } from "services/ticket";
import { updateTransactionStatusByCustomId } from "services/transaction";
import {
  openPaymentErrorModalAtom,
  selectedTicketAtom,
  successAtom,
} from "utils/atoms";
import { PaypalTransactionCaptureStatus } from "utils/mongo/transactions.model";

const PayPalButtonWrapper = ({
  disabled = true,
  items = [],
  amount = {},
  invoiceId,
  customId,
  beforeCreateOrder = async () => {
    await new Promise((resolve) => setTimeout(resolve, 5000));
    return false;
  },
}: {
  disabled?: boolean;
  items?: any[];
  amount?: any;
  invoiceId: string;
  customId: string;
  beforeCreateOrder?: () => Promise<any>;
}) => {
  const [{ isPending }] = usePayPalScriptReducer();
  const [selectedTicket] = useAtom(selectedTicketAtom);
  const [, setSuccess] = useAtom(successAtom);
  const [, setOpenPaymentErrorModal] = useAtom(openPaymentErrorModalAtom);
  const paypalRef = useRef(null);

  const paypalCallback = async (
    status: "approve" | "error" | "cancel",
    data: any
  ) => {
    //console.log(status, data);
    if (status === "approve") {
      if (!selectedTicket) return console.error("No selected ticket");
      // mark discount code as used
      if (selectedTicket.discount) {
        await markDiscount(selectedTicket.discount.id, selectedTicket.quantity);
      }
      // update sold tickets
      await markTicket(selectedTicket.ticket, selectedTicket.quantity);
      // update transaction status as approved
      await updateTransactionStatusByCustomId(
        customId,
        PaypalTransactionCaptureStatus.APPROVED
      );
      setSuccess(true);
    } else if (status === "cancel") {
      console.error(`${status} during paypal transaction`);
      // await deleteTransactionByCustomId(customId); // don't delete transaction in order to trace it
      await updateTransactionStatusByCustomId(
        customId,
        PaypalTransactionCaptureStatus.CANCELLED,
        data
      );
      setOpenPaymentErrorModal(true);
    } else if (status === "error") {
      console.log("error data:::", data.name, data.message);
      console.log("error data:::", String(data));
      const err: any = {};
      err["error"] = data;
      console.log("error json data:::", JSON.stringify(err));
      await updateTransactionStatusByCustomId(
        customId,
        PaypalTransactionCaptureStatus.FAILED,
        String(data)
      );
      setOpenPaymentErrorModal(true);
    } else {
      console.error(
        "Unknown status during paypal transaction, status:::",
        status
      );
      await updateTransactionStatusByCustomId(
        customId,
        PaypalTransactionCaptureStatus.FAILED,
        data
      );
      setOpenPaymentErrorModal(true);
    }
  };

  // doesn't work
  // -> https://stackoverflow.com/questions/43276570/trigger-paypal-checkout-button-click
  //const handleClick = (e) => {
  //  e.preventDefault();
  //  (paypalRef.current as any).click();
  //};

  return (
    <div>
      {isPending ? <Spinner /> : null}
      <div style={{ colorScheme: "none" }}>
        <PayPalButtons
          disabled={disabled}
          //fundingSource={undefined}
          fundingSource={"paypal"}
          style={{
            layout: "vertical",
            color: "blue",
            label: "pay",
            //shape: "pill",
          }}
          createOrder={async (data, actions) => {
            const res = await beforeCreateOrder();
            if (!res) return "";

            return actions.order.create({
              purchase_units: [
                {
                  custom_id: customId,
                  invoice_id: invoiceId,
                  //description: "test description",
                  //reference_id: "reference 123",
                  amount: amount,
                  //amount: {
                  //  currency_code: "USD",
                  //  value: "0.01",
                  //},
                  items: items,
                  payee: {},
                },
              ],
              application_context: {
                shipping_preference: "NO_SHIPPING",
                brand_name: "Moongate",
              },
            });
          }}
          onApprove={async (data, actions) => {
            //console.log(data);
            const { err, res: details } = await to(actions.order!.capture());
            if (err || !details) return paypalCallback("error", err);
            paypalCallback("approve", details);
          }}
          onError={(error) => {
            paypalCallback("error", error);
          }}
          onCancel={(data) => {
            paypalCallback("cancel", data);
          }}
        />
      </div>
    </div>
  );
};

export default PayPalButtonWrapper;
